<template>
  <div :class="{ [`${ns.b('link')}`]: true, [`${ns.is('active')}`]: isActive }">
    <a
      v-if="!!target"
      :class="`${ns.be('link', 'title')}`"
      :href="href"
      :title="title || ''"
      :target="target"
      @click="handleClick"
    >
      {{ title }}
    </a>
    <a
      v-else
      :class="`${ns.be('link', 'title')}`"
      href="javascript:void(0)"
      :title="title || ''"
      @click="handleClick"
    >
      {{ title }}
    </a>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, nextTick, onMounted, onUnmounted, watch } from 'vue'
import { useNamespace } from '@element-plus/hooks'
import { NOOP } from '@element-plus/utils'
import { anchorLinkProps } from './anchor-link'
import type { AnchorLinkPayload } from './anchor-link'
import type { AnchorContext } from './anchor'
import type { AnchorInstance } from './instances'

defineOptions({
  name: 'ElAnchorLink',
})

const props = defineProps(anchorLinkProps)

const ns = useNamespace('anchor')

const anchor = inject<AnchorContext>('anchor', {
  registerLink: NOOP,
  unregisterLink: NOOP,
  scrollTo: NOOP,
})

const anchorContext = inject<AnchorInstance | null>('anchorContext', null)

const isActive = computed(() => {
  return (
    anchorContext &&
    anchorContext.activeLink &&
    anchorContext.activeLink === props.href
  )
})

watch(
  (): string => props.href,
  (newVal: string, oldVal: string) => {
    nextTick(() => {
      anchor.unregisterLink(oldVal)
      anchor.registerLink(newVal)
    })
  }
)

onMounted(() => {
  anchor.registerLink(props.href)
})

onUnmounted(() => {
  anchor.unregisterLink(props.href)
})

function handleClick(): void {
  const { href, title } = props
  const { scrollTo } = anchor
  scrollTo(href)
  if (anchorContext && anchorContext.handleClick) {
    anchorContext.handleClick({ title, href } as AnchorLinkPayload)
  }
}
</script>
